import { render, staticRenderFns } from "./DeliveryAddressList.vue?vue&type=template&id=4437f9f6&"
import script from "./DeliveryAddressList.js?vue&type=script&lang=js&"
export * from "./DeliveryAddressList.js?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
